import { render, staticRenderFns } from "./SanjivaniInstructorBulkIcard.vue?vue&type=template&id=4e0c4945&scoped=true&"
import script from "./SanjivaniInstructorBulkIcard.vue?vue&type=script&lang=js&"
export * from "./SanjivaniInstructorBulkIcard.vue?vue&type=script&lang=js&"
import style0 from "./SanjivaniInstructorBulkIcard.vue?vue&type=style&index=0&id=4e0c4945&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0c4945",
  null
  
)

export default component.exports